import logger from '@design-systems/logger';

/** a common utility to verify that all required prop elements exist */
export const checkForA11yProps = (
  /** Name of the component. Ex: TextArea */
  componentName: string,
  /** Component props */
  props: { [key: string]: any } = {},
  /** An array of strings with the names of props that are sufficient for accessibility */
  propCheck: string[] = []
) => {
  const isMissingElements = propCheck.reduce(
    (acc, key) => acc && !props[key],
    true
  );

  if (isMissingElements) {
    logger.error(
      `${componentName} requires the use of one of these attributes: ${propCheck.join(
        ', '
      )}`
    );
  }
};
